import { render, staticRenderFns } from "./touss.vue?vue&type=template&id=7fd25d08&"
import script from "./touss.vue?vue&type=script&lang=js&"
export * from "./touss.vue?vue&type=script&lang=js&"
import style0 from "./touss.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports